import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { loadUXWizz, trackUXWizzPageView } from "lib/uxwizz";

const UXWizzTracker = function () {
  const location = useLocation();
  const isInitialLoad = useRef(true);

  useEffect(() => {
    loadUXWizz();
  }, []);

  useEffect(() => {
    if (isInitialLoad.current) {
      isInitialLoad.current = false;
      return;
    }

    trackUXWizzPageView();
  }, [location.pathname, location.search]);

  return null;
};

export default UXWizzTracker;
